const getAvAddress = (addresses) => {
    if (addresses.length === 0)
        return null;
    return addresses.find((address) => address.default_shipping) || addresses[0];
};
export const prepareAddressForAv = (addresses = []) => {
    const STREET_ARRAY_INDEXES = {
        streetName: 0,
        streetNumber: 1,
        streetAppartment: 2,
    };
    const addressForAv = getAvAddress(addresses);
    if (addressForAv === null)
        return {};
    return {
        custom_address_street_name: addressForAv.street[STREET_ARRAY_INDEXES.streetName] || "",
        custom_address_street_number: addressForAv.street[STREET_ARRAY_INDEXES.streetNumber] || "",
        custom_address_apartment: addressForAv.street[STREET_ARRAY_INDEXES.streetAppartment] || "",
        custom_city: addressForAv.city || "",
        custom_post_code: addressForAv.postcode || "",
    };
};
//# sourceMappingURL=prepareAddressForAv.js.map